<template>
	<div class="notice-bg" v-show='shouldNoticeShow'>
		<div class="notice">
			<div class="notice-title">{{title}}
			</div>
			<div v-for="item in content" class="notice-content">{{item}}
			</div>
			<div class="notice-confirm" @click="closeNotice">
			  我知道了
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'notify',
		props: ['title', 'content','shouldNoticeShow'],
		methods:{
			closeNotice:function(){
				this.$emit('closeNotice');
			}
		}
	}
</script>

<style>
.notice-bg{
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity .3s ease;
  z-index: 100;
}
.notice{
  width: 3rem;
  border-radius: 0.04rem;
  background-color: white;
  margin:0.8rem auto 0;
}
.notice-title{
  padding-top:0.17rem;
  font-size: 0.2rem;
  font-weight: bold;
  text-align: center;
  color: #333333;
}
.notice-content{
  margin-top: 0.08rem;
  font-size: 0.12rem;
  padding: 0 0.38rem;
  font-size: 0.16rem;
  color:rgba(51,51,51,1);
}
.notice-confirm{
  width: 2.5rem;
  font-size: 0.16rem;
  background:rgba(82,84,255,1);
  color:rgba(255,255,255,1);
  line-height: 0.44rem;
  height: 0.44rem;
  text-align: center;
  display: inline-block;
  border-radius:0.22rem;
  margin: 0.12rem 0.25rem 0.13rem 0.25rem;
}
</style>
